import axios from 'axios'

const server = 'https://www.certificados.hospitaldoispinheiros.com.br'

axios.defaults.baseURL = server;

export { server }

export const http = axios.create()

export default (store, actions) => {
  store.namespaced = true
  if(!store.mutations) store.mutations = {}
  if(!store.actions) store.actions = {}

  store.mutations.function = (state, data) => data(state)

  for(let action in actions) {
    store.actions[action] = actions[action]
  }
}